const assetPropertyDataTypes = {
  anyOf: [
    { type: 'string', title: 'string', const: 'string', description: 'A string value' },
    { type: 'string', title: 'file', const: 'file', description: 'Any stored file' },
    { type: 'string', title: 'fastq', const: 'fastq', description: 'Pointing to a stored FastQ file' },
    { type: 'string', title: 'file', const: 'file', description: 'Pointing to any stored file' },
  ],
};

const schemaOntology = {
  type: 'object',
  properties: {
    assetTypes: {
      type: 'object',
      description: 'Definition of all asset types. Property keys should be the unique asset identifiers.',
      additionalProperties: {
        type: 'object',
        description:
          'Defines an individual asset type. The unique identifier of the asset should be the key of this object.',
        properties: {
          identifier: { type: 'string', description: 'Unique identifier of this asset type' },
          displayName: {
            type: 'string',
            description: 'The name of a single instance of this type of assets (e.g. "Sample").',
          },
          displayNamePlural: {
            type: 'string',
            description: 'The name of a set of instances of this type of assets (e.g. "Samples").',
          },
          icon: {
            type: 'string',
            description: 'Definition of the icon use to visualise this type of asset (e.g. FontAwesome acion name)',
          },
          properties: {
            description: 'The list of all the properties defined for this type of asset.',
            type: 'array',
            items: {
              type: 'object',
              properties: {
                identifier: {
                  type: 'string',
                  description: 'Unique identifier (within the asset type) of the property.',
                },
                displayName: { type: 'string', description: 'Name of the property, as displayed tomthe end user.' },
                dataType: assetPropertyDataTypes,
              },
              required: ['identifier', 'displayName', 'dataType'],
            },
          },
          relations: {
            description: 'The list of all the relations to other asset types defined for this type of asset.',
            type: 'array',
            items: {
              type: 'object',
              properties: {
                identifier: { type: 'string', description: 'Unique identifier of the relation' },
                toAsset: {
                  type: 'string',
                  description:
                    'Identifier of the asset type that is the destination of this relation type (the asset type where this relation type is is defined is the source asset type).',
                },
                displayNameForward: {
                  type: 'string',
                  description:
                    'Forward name of the relation, as displayed to the end user. This should be a verb that connects the sourse to the destination asset (e.g. Sample X "belongs to" Study Y)',
                },
                displayNameReverse: {
                  type: 'string',
                  description:
                    'Reverse name of the relation, as displayed to the end user. This should be a verb that connects the destination to the aource asset (e.g. Study X "contains" Sample X)',
                },
                cardinality: {
                  type: 'string',
                  description: 'Arity of the relation',
                  enum: ['one_to_many', 'many_to_one', 'one_to_one', 'many_to_many'],
                },
              },
              required: ['identifier', 'toAsset', 'displayNameForward', 'displayNameReverse'],
            },
          },
        },
        required: ['identifier', 'displayName', 'displayNamePlural', 'properties', 'relations'],
      },
    },
    entityTypes: {
      type: 'object',
      description:
        'Definition of all entity types. Entities types define types of records that can appear in data context (e.g. genes). Property keys should be the unique entity identifiers.',
      additionalProperties: {
        type: 'object',
        properties: {
          identifier: { type: 'string', description: 'Unique identifier of the entity type' },
          primaryKey: {
            type: 'string',
            description:
              'When an entity type is used in a data context table, identifier of the column that contain the unique identifier of each entity in that table (example: Ensembl IDs).',
          },
          displayName: {
            type: 'string',
            description: 'Name of a single entity as displayed to the end user (e.g.: "Gene").',
          },
          displayNamePlural: {
            type: 'string',
            description: 'Name of a a set of entities as displayed to the end user (e.g.: "Genes").',
          },
        },
        required: ['identifier', 'displayName', 'displayNamePlural'],
      },
    },
  },

  required: ['assetTypes', 'entityTypes'],
  additionalProperties: false,
};

export default schemaOntology;
